import { Component, EventEmitter, HostListener, Input, OnInit, Output, Pipe, PipeTransform, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewEncapsulation, AfterViewInit, } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { GuestService } from 'src/app/shared/services/guest.service';
import { buttonTypes, fieldType } from 'src/app/shared/constants/commonenums';
import { CustomFieldsDTO, SecondaryContactDTO } from 'src/app/shared/Models/PartyModels';
import { environment } from 'src/environments/environment';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import _ from 'lodash';
import { operationType, PricingCategory, PricingType, SelectionType } from 'src/app/shared/Models/WidgetSettingsModels';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { ReservationService } from 'src/app/layout/reservation.service';
// import e from 'express';
import {
  MatSnackBar as MatSnackBar,
  MatSnackBarHorizontalPosition as MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition as MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
    selector: 'app-activities-lite-guest-data',
    templateUrl: './activities-lite-guest-data.component.html',
    styleUrls: ['./activities-lite-guest-data.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ActivitiesLiteGuestDataComponent implements OnInit, AfterViewInit {
  constructor(private rs: ReservationService, private ts: TranslateService, public activityService: GuestService, private dfs: DynamicFormService, private _snackBar: MatSnackBar, public categoryDataPipe: GetCategoryDataPipe) { }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = event.target.innerWidth;
    if (this.screenWidth >= 992) {
      this.expand = true;
    }
  }
  expand = true;
  screenWidth = window.innerWidth;
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  @Input() selectedActivity;
  @Input() customGuestFields;
  @Input() editContactData;
  @Input() notesOptions;
  @Input() promoCodeDetail;
  @Input() noteType: number;
  @Output() guestData = new EventEmitter<any>();
  @Output() notesData = new EventEmitter<any>();
  customGuestFieldsMappingValidations: any = [];
  customGuestFieldsLoad: boolean = false;
  restaurantData: any;
  guestConfig: FieldConfig[] = [];
  termsAndConditionsConfig: FieldConfig[] = [];
  marketingFlag: FieldConfig[] = [];
  mobileNumberLength = 10;
  mandatoryAddOns: any = [];
  editActivityIncomingAddOns: any = [];
  additionalAddOns: any;
  additionalAddonCount = 2;
  mandatoryAddonCount = 2;
  PricingType = PricingType;
  PricingCategory = PricingCategory;
  allEligibleAddOns: any = [];

  @Input() matchedContinousSlots: any[] = [];
  @Input() TimeSlotUnitInMinutes: number = 10;
  @Input() checkedNonDiningLocalTime: string = '';
  @Input() checkedDiningLocalTime: string = '';
  subscriptions: Subscription = new Subscription();
  addSecondaryGuestBtn: ButtonValue;
  secondaryGuest: SecondaryContactDTO[] = [];
  secondaryGuestDetails: SecondaryContactDTO[] = [];
  allowAddingSecondaryGuest: boolean = false;
  additionalSecondaryGuestCount: boolean = true;
  notesRef: any[] = [];
  secondaryGuestVisibileFields = { showGuestNames: false, showprimaryContacts: false, showNotes: false, showCustomFields: false };
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  primaryContact : any;
  mandatoryCategoryAddons: string[] = [];
  cancellationDescription: string = ''
  @Input() stayGuestList: any = [];
  SelectedGuestToFillIn: any = {};

  ngOnInit() {
    let restaurantId = this.getRestaurantId();
    this.restaurantData = this.activityService.widgetSettings.PropertyWidgetSettings.find(property => property.RestaurantId == restaurantId);
    this.notesRef = this.resetSecondaryNotes(_.cloneDeep(this.notesOptions));
    if (this.selectedActivity && this.selectedActivity.SpecialMealId && !this.activityService.isDining) {
      this.allowAddingSecondaryGuest = this.selectedActivity.AllowAddingSecondaryGuest || false;
      if (  this.allowAddingSecondaryGuest && this.activityService.selectedSize > 1) {
        this.allowAddingSecondaryGuest = true;
      }
      else {
        this.allowAddingSecondaryGuest = false;
      }
      this.secondaryGuestVisibileFields.showGuestNames = this.selectedActivity.GuestNames || false;
      this.secondaryGuestVisibileFields.showprimaryContacts = this.selectedActivity.PrimaryContacts || false;
      this.secondaryGuestVisibileFields.showNotes = this.selectedActivity.ContactNotes || false;
      this.secondaryGuestVisibileFields.showCustomFields = this.selectedActivity.CustomGuestFields || false;
    } else {
      this.allowAddingSecondaryGuest = this.restaurantData?.WidgetCustomization.AllowAdditionalGuestDetails || false;
      if (this.allowAddingSecondaryGuest && this.activityService.selectedSize > 1) {
        this.allowAddingSecondaryGuest = true;
      }
      else {
        this.allowAddingSecondaryGuest = false;
      }
      this.secondaryGuestVisibileFields.showGuestNames = this.restaurantData?.WidgetCustomization.GuestNames || false;
      this.secondaryGuestVisibileFields.showprimaryContacts = this.restaurantData?.WidgetCustomization.PrimaryContacts || false;
      this.secondaryGuestVisibileFields.showNotes = this.restaurantData?.WidgetCustomization.ContactNotes || false;
      this.secondaryGuestVisibileFields.showCustomFields = this.restaurantData?.WidgetCustomization.CustomGuestFields || false;
    }
    if (this.allowAddingSecondaryGuest) {
      let secondaryGuestFields = Object.entries(this.secondaryGuestVisibileFields);
      this.allowAddingSecondaryGuest = secondaryGuestFields?.find(field => field[1] == true) ? true : false;
    }

    if(this.activityService?.selectedSpecialMeal?.CancellationPolicy && this.activityService?.selectedSpecialMeal?.CancellationPolicy != '') {
      this.cancellationDescription = this.activityService?.selectedSpecialMeal?.CancellationPolicy;
    }
    else if(!this.activityService?.selectedSpecialMeal && this.activityService?.isDining && this.activityService?.selectedDining?.CancellationPolicy && this.activityService?.selectedDining?.CancellationPolicy != '') {
      this.cancellationDescription = this.activityService?.selectedDining?.CancellationPolicy;
    }
    else if(!this.activityService?.selectedSpecialMeal && this.activityService?.isNonDining && this.activityService?.selectedNonDining?.CancellationPolicy && this.activityService?.selectedNonDining?.CancellationPolicy != '') {
      this.cancellationDescription = this.activityService?.selectedNonDining?.CancellationPolicy;
    }
    this.customGuestFieldsMappingValidations = this.restaurantData?.customGuestFieldsMappingValidations;
    this.createGuestConfig();
    this.createCustomFieldsConfig();
    //🐞 Bug Fix | Issue: 48285 | Root: guest detail not retained after navigation back | Fix: retained the form data from the editData which holds the guest data | By: Maris | Date: 02/01/26
    let editContact = this.editContactData?.SecondaryContacts ?? this.editContactData?.SecondaryContactsList;
    if (editContact && editContact.length > 0) {
      this.secondaryGuestDetails =editContact
    
      if(this.stayGuestList?.length){
      this.SelectedGuestToFillIn = this.stayGuestList[0];
    }
   
      this.secondaryGuestDetails.map((contact,index) => {
        contact.isValid = true;
       // contact.count = index + 1;
      })
      this.secondaryGuest = editContact
    }
    this.activityService.addOnList = this.restaurantData.Addons || [];
    if (this.activityService.isNonDining || this.activityService.isTableReservation) this.getOpenBookingAddOns();
    else 
      if(this.activityService.isDining){
        this.getOpenBookingAddOns();
      }
      else
        this.loadAddOns();
      //Bug Fix 66099: Reserve - 26.3.4 -Universal Widget Mandatory Add-on Pricing Missing | Author : Jathiswar Bhaskaran | Date : 20/06/2026
    if(editContact && editContact.length > 0) this.validateBookingCount();
    // this.addOnTempList = this.addOnTempList.slice(0,2)
  }

  SelectedGuestToFillInChangeHandler(){
    this.editContactData = this.SelectedGuestToFillIn;
    //🐞 Bug Fix | Issue: 49238 | Root: CountryId becomes undefined when guest is chosen from dropdown | Fix: when countryId is undefined, get the default country | By: Jeba Sherin | Date: 11/02/2026
    const countryId = this.editContactData.CountryId || 
    Utilities.getDefaultCountry(
      this.activityService.countriesList || [], 
      this.restaurantData?.Country
    )?.Id;
    this.components.last.form.get('firstName').setValue(this.editContactData.FirstName)
    this.components.last.form.get('lastName').setValue(this.editContactData.LastName)
    this.components.last.form.get('aliasName')?.setValue(this.editContactData.AliasName)
    this.components.last.form.get('CountryId').setValue(countryId)
    this.components.last.form.get('phone').setValue(this.editContactData.PhoneNumber)
    this.components.last.form.get('email').setValue(this.editContactData.EmailAddress)
    this.countryCodeChange();
    let guestFields = ['firstName','lastName','aliasName'];
    if(this.SelectedGuestToFillIn.GuestProfileServiceId === -1){
     this.enableGuestDetails(guestFields);
    }
    else{
      this.disableGuestDetails(guestFields);
    }
  }

  enableGuestDetails(guestFields){
    guestFields.forEach( field=> {
      this.components.last.form.get(field).enable();
    });
  }
  disableGuestDetails(guestFields){
    guestFields.forEach( field=> {
      this.components.last.form.get(field).disable();
    });
  }
  getOpenBookingAddOns() {

    let selectedDate = moment((this.activityService.isTableReservation || this.activityService.isDining) ? this.checkedDiningLocalTime : this.checkedNonDiningLocalTime).format('YYYY-MM-DD');
    let startTime = moment((this.activityService.isTableReservation || this.activityService.isDining)  ? this.checkedDiningLocalTime : this.matchedContinousSlots[0]).format('HH:mm');
    let endTime = moment((this.activityService.isTableReservation || this.activityService.isDining)  ? this.checkedDiningLocalTime : this.matchedContinousSlots[this.matchedContinousSlots.length - 1]).format('HH:mm');

    if(this.activityService.isDining){
      startTime = moment(this.checkedDiningLocalTime).format('HH:mm');
      endTime = moment(this.checkedDiningLocalTime).format('HH:mm');
    }

    const reqObj = {
      RestaurantId: this.activityService.isNonDining ? this.activityService.selectedNonDining.RestaurantId : this.activityService.selectedDining.RestaurantId,
      StartTime: moment(`${selectedDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ss'),
      EndTime: moment(`${selectedDate} ${endTime}`).add(this.TimeSlotUnitInMinutes, 'm').format('YYYY-MM-DDTHH:mm:ss')
    }

    this.activityService.startLoader();
    this.subscriptions.add(this.rs.getOpenBookingAddOns(reqObj, this.activityService.selectedSpecialMeal?.Id).subscribe(response => {
      this.activityService.addOnList = response?.Payload || [];
    }, (err) => { },
      () => {
        this.activityService.stopLoader();
        this.loadAddOns();
      }));
  }


  getRestaurantId() {
    if (this.activityService.isDining) return this.activityService.selectedDining.RestaurantId;
    else if (this.activityService.isNonDining) return this.activityService.selectedNonDining.RestaurantId;
    else return this.activityService.selectedActivities.RestaurantId;
  }

  expandAddOn() {
    this.expand = !this.expand
  }

  loadAddOns() {
    let getAddOns = Utilities.getAddons(this.activityService.addOnList, this.activityService.selectedSpecialMeal?.Id, this.activityService.isNonDining);

    this.mandatoryAddOns = [];
    this.additionalAddOns = [];

    if (this.activityService.operation == operationType.edit && this.activityService.editData) {
      this.editActivityIncomingAddOns = this.activityService.editData.BookingContactAddonItems ? this.activityService.editData?.BookingContactAddonItems : {};
    }

    // if(this.activityService.isNonDining) this.activityService.addOnList = this.allEligibleAddOns;

    // if(!this.activityService.isNonDining)
    getAddOns.forEach(item => {
      let availableMandatoryAddOn = this.activityService.addOnList.find(addOnData => addOnData.AddonId == item.AddonId);
      if (availableMandatoryAddOn) {
        availableMandatoryAddOn['IsVisible'] = item.IsVisible;
        availableMandatoryAddOn['MaxQuantity'] = item.MaxQuantity
        availableMandatoryAddOn['MinQuantity'] = item.MinQuantity
        availableMandatoryAddOn['Price'] = availableMandatoryAddOn.AddOnDetails?.length ? availableMandatoryAddOn.AddOnDetails[0].Price : 0;
        availableMandatoryAddOn['IsCategoryLevelMandatory'] = item.IsCategoryLevelMandatory;

        if (!this.activityService.isNonDining && !this.activityService.isDining)
          availableMandatoryAddOn['OverAllQuantity'] = this.activityService.selectedSlot ? this.activityService.selectedSlot.AddOnAvailability?.find(data => data.AddonId == availableMandatoryAddOn.AddonId)?.OverAllQuantity : 0;
        else availableMandatoryAddOn['OverAllQuantity'] = item['OverAllQuantity'] || 0;

        if (!this.activityService.isNonDining && !this.activityService.isDining)
          availableMandatoryAddOn['AvailableQuantity'] = this.activityService.selectedSlot ? this.activityService.selectedSlot.AddOnAvailability?.find(data => data.AddonId == availableMandatoryAddOn.AddonId)?.AvailableQuantity : 0
        else availableMandatoryAddOn['AvailableQuantity'] = item['AvailableQuantity'] || 0;

        availableMandatoryAddOn['IsMandatory'] = item.IsMandatory;

        if (!this.activityService.isNonDining && !this.activityService.isDining)
          availableMandatoryAddOn['IsUnlimited'] = this.activityService.selectedSlot?.AddOnAvailability?.find(data => data.AddonId == availableMandatoryAddOn.AddonId)?.IsUnlimited || false;
        else availableMandatoryAddOn['IsUnlimited'] = item['IsUnlimited'];

        availableMandatoryAddOn['PricingType'] = availableMandatoryAddOn.AddOnDetails?.length ? availableMandatoryAddOn.AddOnDetails[0].PricingType : null;
        availableMandatoryAddOn['PricingCategory'] = availableMandatoryAddOn.AddOnDetails?.length ? availableMandatoryAddOn.AddOnDetails[0].PricingCategory : null;
        let addOnQuantity = 0;
        if (item.IsMandatory) {
          if (this.editActivityIncomingAddOns && this.editActivityIncomingAddOns.length > 0) {
            let selectedAddOnCreate = this.editActivityIncomingAddOns.filter(x => x.AddonId == item.AddonId);
            if (selectedAddOnCreate && selectedAddOnCreate.length > 0) {
              if (availableMandatoryAddOn.SelectionType == SelectionType.PerGuest) {
                availableMandatoryAddOn.selectedQuantity = this.activityService.selectedSize;
              }
              else {
                availableMandatoryAddOn.selectedQuantity = selectedAddOnCreate[0].AddonCount;
              }
            }
            else {
              availableMandatoryAddOn.selectedQuantity = this.getAddOnQuantity(availableMandatoryAddOn);
            }
          }
          else {
            availableMandatoryAddOn.selectedQuantity = this.getAddOnQuantity(availableMandatoryAddOn);
          }
          this.mandatoryAddOns.push(availableMandatoryAddOn)
          this.allEligibleAddOns.push(availableMandatoryAddOn);
        }

        else {
          if (this.editActivityIncomingAddOns && this.editActivityIncomingAddOns.length > 0) {
            let selectedAddOnCreate = this.editActivityIncomingAddOns.filter(x => x.AddonId == item.AddonId);
            if (selectedAddOnCreate && selectedAddOnCreate.length > 0) {
              availableMandatoryAddOn.selectedQuantity = selectedAddOnCreate[0].AddonCount;
            }
            else {
              availableMandatoryAddOn.selectedQuantity = 0;
            }
          }
          else {
            availableMandatoryAddOn.selectedQuantity = 0;
          }
          this.additionalAddOns.push(availableMandatoryAddOn)
          this.allEligibleAddOns.push(availableMandatoryAddOn);
        }

        // if (item.IsMandatory || item.IsCategoryLevelMandatory) {
        //   addOnQuantity = this.getAddOnQuantity(availableMandatoryAddOn)
        // }
        // availableMandatoryAddOn.selectedQuantity = addOnQuantity;
        // if (this.data) {
        //   if (this.data.BookingContactAddonItems) {
        //     let bookedAddon = this.data.BookingContactAddonItems.find(addOn => addOn.AddonId == availableMandatoryAddOn.AddonId);
        //     if (bookedAddon && bookedAddon != undefined && bookedAddon != null) {
        //       availableMandatoryAddOn.selectedQuantity = bookedAddon.AddonCount || 0;
        //     }
        //   }
        //   else if (this.data.SelectedAddOns) {
        //     availableMandatoryAddOn.selectedQuantity = this.data.SelectedAddOns.find(addOn => addOn.AddonId == availableMandatoryAddOn.AddonId)?.Quantity || 0;
        //   }
        // }
        // availableMandatoryAddOn.selectedQuantity = Number( availableMandatoryAddOn.selectedQuantity);
        // if (item.IsMandatory || item.IsCategoryLevelMandatory) {
        //   this.mandatoryAddOns.push(availableMandatoryAddOn);
        //   this.allEligibleAddOns.push(availableMandatoryAddOn);

        // }
        // else {
        //   this.additionalAddOns.push(availableMandatoryAddOn);
        //   this.allEligibleAddOns.push(availableMandatoryAddOn);

        // }

      }
    })
    this.mandatoryAddOns = this.getAddOnsGroupedByCategory(this.mandatoryAddOns)
    this.allEligibleAddOns = this.allEligibleAddOns.filter(_a => _a.IsVisible);
    this.allEligibleAddOns = _.orderBy(this.allEligibleAddOns, 'IsMandatory', 'desc');
    this.additionalAddOns = this.getAddOnsGroupedByCategory(this.additionalAddOns)
    //this.ps.addOnList = _.flatten([_.flatten(_.map(this.mandatoryAddOns, 'Addons')), _.flatten(_.map(this.additionalAddOns, 'Addons'))]);
    this.checkCategoryMandatoryAddons();

  }


  getAddOnQuantity(addon) {
    //changes for future planned - based on selectiontype
    switch (addon.SelectionType) {
      case SelectionType.PerGuest:
        let addonMinQuantity: number = 0;
        if (addon.IsMandatory) {
          addonMinQuantity = this.activityService.selectedSize;
        }
        else {
          addonMinQuantity = addon.MinQuantity;
        }
        return addonMinQuantity;
        break;
      case SelectionType.PerBooking:
        return addon.MinQuantity
        break;
      case SelectionType.PerLesson:
        return addon.MinQuantity
        break;
    }
  }

  getAddOnsGroupedByCategory(addOnList) {
    return _.chain(addOnList)
      .groupBy("CategoryId")
      .map((value, key) => {
        return {
          CategoryId: value[0].CategoryId,
          Addons: value
        }
      })
      .value();
  }
  ngAfterViewInit() {
    console.log(this.activityService)
    this.getFormValue();
  }
  getFormValue() {
    if (this.components.first.form) {
      this.countryCodeChange();
      this.applyPrimaryContactControlState();
      this.components.first.form.valueChanges.subscribe(data => {
        this.getPrimaryGuestData();
      })
      if(this.editContactData && this.activityService.operation === operationType.edit ){
        this.components.first.form.markAllAsTouched();
      }
    }
    if (this.components.last.form) {
      this.components.last.form.valueChanges.subscribe(data => {
        this.getPrimaryGuestData();
      })
    }
  }

  private applyPrimaryContactControlState() {
    const form = this.components?.first?.form;
    if (!form) return;

    const disableGuestNameFields = this.activityService.IsStayGuest || this.activityService.IsMember;
    ['firstName', 'lastName', 'aliasName'].forEach(field => {
      const control = form.get(field);
      if (!control) return;
      disableGuestNameFields ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
    });

    ['CountryId', 'phone', 'email'].forEach(field => {
      const control = form.get(field);
      if (!control) return;
      this.activityService.IsMember ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
    });
  }

  decreaseAddOn(addOn) {
    if (addOn.IsMandatory && addOn.selectedQuantity - 1 < addOn.MinQuantity && addOn.SelectionType != SelectionType.PerGuest) {
    }
    else if (addOn.IsMandatory && addOn.SelectionType == SelectionType.PerGuest && (addOn.selectedQuantity - 1 < this.activityService.selectedSize)) {
    }
    else {
      if (addOn.selectedQuantity - 1 >= 0)
        addOn.selectedQuantity = addOn.selectedQuantity - 1;
    }
    this.checkCategoryMandatoryAddons();
  }
  increaseAddOn(addOn) {
    if ((!addOn.IsUnlimited || (addOn.IsUnlimited && addOn.MaxQuantity)) && ((addOn.selectedQuantity == addOn.MaxQuantity) || (addOn.SelectionType !== SelectionType.PerLesson && (addOn.selectedQuantity + 1) > addOn.AvailableQuantity))) {
    }
    else if (addOn.IsMandatory && addOn.SelectionType == SelectionType.PerGuest && (addOn.selectedQuantity + 1 > this.activityService.selectedSize)) {

    }
    else {
      addOn.selectedQuantity = addOn.selectedQuantity + 1;
    }
    this.checkCategoryMandatoryAddons();
  }

  addonQuantityValidations(event, addon) {
    if (addon.SelectionType == SelectionType.PerLesson && (!addon.IsUnlimited || (addon.IsUnlimited && addon.MaxQuantity))) {
    addon.selectedQuantity = addon.IsMandatory ? addon.MaxQuantity : (event.target.value >= 1) ? 1 : 0;
    } else if (addon.SelectionType == SelectionType.PerGuest && addon.IsMandatory && (!addon.IsUnlimited || (addon.IsUnlimited && addon.MaxQuantity))) {
    addon.selectedQuantity = this.activityService.selectedSize;
    } else if (addon.IsMandatory && (event.target.value == '' || event.target.value < addon.MinQuantity)) {
    addon.selectedQuantity = addon.MinQuantity;
    } else if ((event.target.value == '' || event.target.value < addon.MinQuantity)) {
    addon.selectedQuantity = 0;
    } else if(addon.IsUnlimited && addon.MaxQuantity && (event.target.value > addon.MaxQuantity || event.target.value > addon.AvailableQuantity)) {
      addon.selectedQuantity = addon.MaxQuantity;
    } else if ((!addon.IsUnlimited) && (event.target.value > addon.MaxQuantity || event.target.value > addon.AvailableQuantity)) {
    addon.selectedQuantity = addon.AvailableQuantity < addon.MaxQuantity ? addon.AvailableQuantity : addon.MaxQuantity; 
    }
    if (Number(event.target.value) !== Number(addon.selectedQuantity)) {
      let message = ''
      const minsize = addon.IsMandatory ? addon.MinQuantity : 0;
      const maxsize = addon.MaxQuantity;
      this.ts.get('missMatchAddonQuantity', { minsize, maxsize }).subscribe(msgVal => message = msgVal);
      this._snackBar.open(message, 'Close', {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: 3000,
      });
    }
    this.checkCategoryMandatoryAddons();
  }

  checkCategoryMandatoryAddons(){
    let _categoryAddons = {}
    let _missingCategoryAddon: string[] = [];

    this.allEligibleAddOns.forEach(addon => {
      if(addon.IsCategoryLevelMandatory){
        _categoryAddons[addon.CategoryId] = (_categoryAddons[addon.CategoryId] || 0) + addon.selectedQuantity;
      }
    })

    Object.entries(_categoryAddons).forEach(([key, value]) => {
      if(!value){
        let categoryName = this.categoryDataPipe.transform({CategoryId: key}, this.restaurantData.PreferencesCategories, 'Text')
        _missingCategoryAddon.push(categoryName)
      }
    })
    
    this.mandatoryCategoryAddons = _missingCategoryAddon;

    this.validateBookingCount();
  }

  loadAllAddOns(type) {
    if (type == "mandatory") {
      this.mandatoryAddonCount = this.mandatoryAddOns.length;
    }
    else {
      this.additionalAddonCount = this.additionalAddOns.length
    }
  }

  showMinAddOns(type) {
    if (type == "mandatory") {
      this.mandatoryAddonCount = 2
    }
    else {
      this.additionalAddonCount = 2
    }
  }

  getCountryIdValue(data: any): number {
    if (data?.CountryId) {
      return data.CountryId;
    }
    
    /** 🐞 Bug Fix | Issue: 49431 | Root: CountryPhoneCode not fetched properly | Fix: Added CountryPhoneCode | By: Hope | Date: 14/02/2026 */
    if (data?.CountryPhoneCode) {
      const country = this.activityService.countriesList?.find(
        c => c.CountryPhoneCode === data.CountryPhoneCode
      );
      if (country?.Id) {
        return country.Id;
      }
    }
    
    const defaultCountry = Utilities.getDefaultCountry(
      this.activityService.countriesList ?? [],
      this.restaurantData.Country
    );
    return defaultCountry?.Id ?? 0;
  }

  createGuestConfig() {
   // 🐞 Bug Fix | Issue: 49536 | Root: Previous booking datas are prepopulated for new booking | Fix: Editcontactdata set for edit operation | By: Jeba Sherin | Date: 20/02/2026
   if(this.stayGuestList?.length && this.activityService.operation !== operationType.edit){
      this.SelectedGuestToFillIn = this.stayGuestList[0];
      this.editContactData = this.SelectedGuestToFillIn;
    }
    //🐞 Bug Fix | Issue: 46958 | Root: Restore is not happening for secondary guest details  | Fix: Restore secondary guest data if secondary contacts exist | By: Jerlin C S | Date: 19/03/2026
   // Only overwrite editContactData if there's no valid restored data (check if FirstName exist
  //  if(this.activityService.operation !== operationType.edit){
  //     this.editContactData = this.SelectedGuestToFillIn;
  //  }
   let data = this.editContactData;
    this.guestConfig = [
      {
        type: 'input',
        name: 'firstName',
        label: this.ts.instant('firstName'),
        inputType: 'text',
        showErrorText: true,
        isFormArray: false,
        errorMessage: this.ts.instant('firstNameRequired'),
        validation: [Validators.required, Validators.minLength(this.activityService.ContactMinLength ?? 2)],
        value: (data && data.FirstName) ? data.FirstName : '',
        appearanceOutline: true,
        charLength: this.activityService.ContactMinLength ?? 2
      },
      {
        type: 'input',
        label: this.ts.instant('lastName'),
        name: 'lastName',
        inputType: 'text',
        showErrorText: true,
        isFormArray: false,
        charLength: this.activityService.ContactMinLength ?? 2,
        errorMessage: this.ts.instant('lastNameRequired'),
        value: (data && data.LastName) ? data.LastName : '',
        validation: [Validators.required, Validators.minLength(this.activityService.ContactMinLength ?? 2)],
        appearanceOutline: true
      },
      {
        type: 'input',
        label: this.ts.instant('aliasName'),
        name: 'aliasName',
        inputType: 'text',
        showErrorText: true,
        isFormArray: false,
        //errorMessage: this.ts.instant('lastNameRequired'),
        value: (data && data.AliasName) ? data.AliasName : '',
        appearanceOutline: true,
        hide: this.activityService?.widgetSettings?.ShowAliasName ? false : true
      },
      {
        type: 'select',
        name: 'CountryId',
        inputType: 'number',
        class: 'guest-view__mobile-code-edit', // Do not modify the className, there is a dependency for editGuest details.
        options: this.activityService.countriesList ? this.activityService.countriesList.map(element => {
          return { id: element.Id, value: element.CountryPhoneCode + '  (' + element.Name + ' )' }
        }) : [],
        cellClick: this.countryCodeChange.bind(this, true),
        value: this.getCountryIdValue(data),
        validation: [Validators.required],
        isFormArray: false,
        appearanceOutline: true
      },
      {
        type: 'input',
        name: 'phone',
        inputType: 'text',
        label: this.ts.instant('mobile'),
        directive: 'numberOnly',
        //validation: [Validators.minLength(minMobileLength)], //minlength has to be included
        showErrorText: true,
         blurClick: this.mobileNumberChange.bind(this),
        isFormArray: false,
        value: (data && data.PhoneNumber) ? data.PhoneNumber : '',
        appearanceOutline: true,
        // isPhoneNumber:true,
        isMandatory: true,
        validation: [Validators.required],
        numberFormat: 'phoneNumber'
      },
      {
        type: 'input',
        label: this.ts.instant('email'),
        name: 'email',
        inputType: 'email',
        showErrorText: true,
        isFormArray: false,
        errorMessage: this.ts.instant('emailRequired'),
        validation: [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$')],
        value: (data && data.EmailAddress) ? data.EmailAddress : '',
        appearanceOutline: true
      }
    ];
    this.addPromocodeConfig();
    this.addMarketingCollateralsConfig();
  }
  addPromocodeConfig() {
    if (this.activityService.selectedDining.WidgetCustomization?.DisplayPromoCode && !this.selectedActivity?.SpecialMealId) {
      this.guestConfig.push({
        type: 'input',
        name: 'promoCode',
        label: this.activityService.selectedDining.WidgetCustomization?.PromoCodeLabel ? this.activityService.selectedDining.WidgetCustomization?.PromoCodeLabel : this.ts.instant('promoCode'),
        inputType: 'text',
        showErrorText: true,
        isFormArray: false,
        value: this.promoCodeDetail ? this.promoCodeDetail : '',
        appearanceOutline: true,
        placeholder: this.activityService.selectedDining.WidgetCustomization?.PromoCodeLabel ? this.activityService.selectedDining.WidgetCustomization?.PromoCodeLabel : this.ts.instant('promoCode'),
      })
    }
  }

  countryCodeChange() {
   let countryCode = this.components.first.form.get('CountryId').value;
    if (countryCode) {
      const selectedCountryCode = this.activityService.countriesList.find((country) => {
        return country.Id === countryCode;
      });
      this.activityService.selectedCountryId = selectedCountryCode.Id;
      this.dfs.selectedCountryCode = selectedCountryCode.CountryPhoneCode;
      this.changeMobileLength();
      this.mobileNumberChange();
    }
  }

  mobileNumberChange() {
    let mobileNumber = this.components.first.form.get('phone').value;
    if (mobileNumber) {
      mobileNumber = this.dfs.onInputChange(mobileNumber, false);
      this.changeMobileLength();
    }
    this.components.first.form.get('phone').setValue(mobileNumber, { emitEvent: false });
    // 🐞 Bug Fix | Issue: 49424 | Root: mobile number field validation not updated for every key stroke | Fix: updated mobile number form field validation | By: Maris | Date: 13/02/2026
    this.components.first.form.get('phone').updateValueAndValidity();
  }

  changeMobileLength() {
    if (this.dfs.requiredPhoneNumberLength$) {
      const count = this.dfs.requiredPhoneNumberLength$;
      this.mobileNumberLength = count;
      this.components.first.form.controls['phone'].setValidators([Validators.required, Validators.minLength(this.mobileNumberLength), Validators.maxLength(this.mobileNumberLength)]);
      this.components.first.form.updateValueAndValidity({ emitEvent: false });
      // 🐞 Bug Fix | Issue: 49424 | Root: mobile number field validation not updated for every key stroke | Fix: updated mobile number form field validation | By: Maris | Date: 13/02/2026
      this.components.first.form.get('phone').updateValueAndValidity();
    }
    else {
      this.dfs.requiredPhoneNumberLength$ = this.dfs.countriesList.find(country => country.Id == (this.activityService.selectedCountryId || this.dfs.selectedCountryCode))?.PhoneNumberLength;
      this.components.first.form.controls['phone'].setValidators([Validators.required, Validators.minLength(this.dfs.requiredPhoneNumberLength$), Validators.maxLength(this.dfs.requiredPhoneNumberLength$)]);
      this.components.first.form.updateValueAndValidity({ emitEvent: false });
       // 🐞 Bug Fix | Issue: 49424 | Root: mobile number field validation not updated for every key stroke | Fix: updated mobile number form field validation | By: Maris | Date: 13/02/2026
      this.components.first.form.get('phone').updateValueAndValidity();
    }
  }

  addMarketingCollateralsConfig() {
    if (this.activityService.selectedDining.MarketingFlagEnabled && this.activityService.selectedDining?.MarketingFlagDescription && !this.selectedActivity?.SpecialMealId) {
      this.marketingFlag = [{
        type: 'checkbox',
        placeholder: this.activityService.selectedDining?.MarketingFlagDescription ? JSON.parse(this.activityService.selectedDining?.MarketingFlagDescription)[0] : '',
        value: (this.editContactData && this.editContactData) ? this.editContactData.MarketingOptedIn : false,
        name: 'MarketingOptedIn',
        class: 'p3',
        isFormArray: false,
        innerHTMLdata: true
      }]
    }
  }
  createCustomFieldsConfig() {
    if (this.customGuestFields) {
      this.customGuestFields.map((customField, index) => {
        let fieldConfig: FieldConfig;
        if (this.showCustomFieldBasedOnActivity(customField.Id)) {
          if (customField.FieldType == fieldType[0]) {
            fieldConfig = {
              type: 'input',
              name: `customField_${customField.Id}`,
              inputType: 'text',
              label: customField.FieldName,
              placeholder: customField.FieldDescription,
              class: 'guest-view__custom-fields-edit',
              id: customField.Id,
              isFormArray: false,
              appearanceOutline: true,
              value: this.getCustomGuestFieldsValue(customField.Id, fieldType[0]),
              validation: this.customValidationRequired(customField)
            };
          } else if (customField.FieldType == fieldType[1]) {
            let Options = [];
            Options = customField.FieldOptions.split(',').map(x => { return { id: x, value: x } });
            fieldConfig = {
              type: 'select',
              label: customField.FieldName,
              name: `customField_${customField.Id}`,
              placeholder: customField.FieldDescription,
              options: Options,
              class: 'guest-view__custom-fields-edit',
              id: customField.Id,
              isFormArray: false,
              appearanceOutline: true,
              value: this.getCustomGuestFieldsValue(customField.Id, fieldType[1]),
              validation: this.customValidationRequired(customField)
            }
          }
          if (fieldConfig) {
            this.guestConfig.push(fieldConfig);
          }
        }
      })
    }
    this.customGuestFieldsLoad = true;
    setTimeout(() => {
      this.getPrimaryGuestData();
    }, 1000)
  }
  getCustomGuestFieldsValue(Id, type) {
    let customValue;
    if (this.editContactData && this.editContactData.ContactCustomFields && this.editContactData.ContactCustomFields.length) {
      customValue = this.editContactData.ContactCustomFields.find(field => field.CustomFieldId === Id)
    }
    return type == fieldType[0] ? (customValue ? customValue['CustomFieldValue'] : '') : (customValue ? customValue['CustomFieldValue'] : '');
  }
  getPrimaryGuestData() {
    let guest = this.components.first.form.getRawValue();
    let contact = {
      FirstName: guest.firstName,
      LastName: guest.lastName,
      AliasName: guest.aliasName,
      EmailAddress: guest.email,
      PhoneNumber: guest.phone,
      CountryId: guest.CountryId,
      Id:this.editContactData?.Id || null,
      /** 🐞 Bug Fix | Issue: 50699 | Root: GuestProfileServiceId is null | Fix: modified GuestProfileServiceId logic | By: Hope | Date: 26/03/2026 */
      GuestProfileServiceId: this.editContactData?.GuestProfileServiceId ? this.editContactData?.GuestProfileServiceId : null,
      ContactCustomFields: this.bindCustomGuestFieldsValue(),
      MarketingOptedIn: this.components.last?.form?.value.MarketingOptedIn,
      promoCode: guest.promoCode,
      StayConfirmationCode: this.editContactData?.StayConfirmationCode || null,//🐞 Bug Fix | Issue: 49413 | Root: stay guest details like confirmationCode, start & end date not passed | Fix: stay info sent | By: Mahalakshmi Kalidas | Date: 17/02/26
      Staystartdate: this.editContactData?.Staystartdate || null,
      StayEnddate: this.editContactData?.StayEnddate || null,
      PackageName: this.editContactData?.PackageName || null,
      RoomNumber: this.editContactData?.RoomNumber || null,
    }
    this.primaryContact = contact;
    //🐞 Bug Fix | Issue: 48547 | Root: guest detail not retained after navigation back and order summary page went blank after editing reservation | Fix: retained the form data from the editData which holds the guest data  and stored it formData | By: Maris | Date: 07/01/26
    this.activityService.guestData = contact;
    const _isFormValid = this.isFormValid(this.components.first.form);
    this.guestData.emit({ formValid: _isFormValid && !this.mandatoryCategoryAddons?.length, guestContact: contact , secondaryContact: this.secondaryGuestDetails });

  }
  bindCustomGuestFieldsValue() {
    let CustomFieldsList: CustomFieldsDTO[] = [];
    if (this.customGuestFields && this.customGuestFields.length > 0) {
      this.customGuestFields.forEach((field) => {
        if (this.components.first.form.value['customField_' + field.Id.toString()] != null) {
          let customField = new CustomFieldsDTO();
          customField.CustomFieldId = Number(field.Id);
          customField.CustomFieldValue = this.components.first.form.value['customField_' + field.Id.toString()];
          customField.CustomFieldName = field.FieldName;
          CustomFieldsList.push(customField);
        }
      })
    }
    return CustomFieldsList;
  }
  toggleSelection(noteOptions) {
    this.notesData.emit({ noteOptions: noteOptions });

  }

  showCustomFieldBasedOnActivity(customFieldId) {
    /** 🐞 Bug Fix | Issue: ${1:46945} | Root: ${2:selected specailmeal not present in the varible} | Fix: ${3:taken specailMealId from the activityService} | By: Mahalakshmi Kalidas | Date: 2025/11/18 */
    let specialMealId = this.activityService.selectedSpecialMeal ? this.activityService.selectedSpecialMeal.Id : -1;
    let activitiesCustomGuestFields = this.customGuestFieldsMappingValidations;
    if (activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)) {
      let activeActivity = activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)
      if (activeActivity.CustomFields.filter(field => field.FieldId === customFieldId && field.AvailableForWebReservation == true)?.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }
  customValidationRequired(field) {
    if (this.customFieldMandatory(field)) {
      return [Validators.required];
    } else {
      return [];
    }
  }
  customFieldMandatory(field) {
    let specialMealId = (this.selectedActivity && this.selectedActivity.SpecialMealId) ? this.selectedActivity?.SpecialMealId : -1;
    let activitiesCustomGuestFields = this.customGuestFieldsMappingValidations;
    let CustomFields = activitiesCustomGuestFields.find(activity => activity.ActivityId == specialMealId)?.CustomFields
    let validations = CustomFields?.find(customField => customField?.FieldId === field?.Id)?.Validations;
    if (validations?.length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  addSecondaryGuestDetails() {
    this.secondaryGuest.push({
      FirstName: null,
      LastName: null,
      AliasName: null,
      EmailAddress: null,
      PhoneNumber: null,
      CountryId: null,
      ContactCustomFields: null,
      Notes: _.cloneDeep(this.notesRef),
      Id: null,
      GuestProfileServiceId: null,
      ContactId: null,
      ContactNotes: null,
      PartyId: null,
      isValid: false,
      count: this.secondaryGuest.length,
    });
    this.secondaryGuestDetails = this.secondaryGuest;

    this.validateBookingCount();

  }

  deleteSecondaryGuest({index, contactId}) {
    if(contactId){
      this.secondaryGuest = this.secondaryGuest.filter(detail => detail.ContactId !== contactId);
    } else if(index >= 0){
      this.secondaryGuest = this.secondaryGuest.filter(detail => detail.count !== index);
    }
    this.secondaryGuestDetails = this.secondaryGuest;
    this.validateBookingCount();
  }

  validateBookingCount() {
    if (this.selectedActivity && this.editContactData?.Id) {
      this.additionalSecondaryGuestCount = this.secondaryGuestDetails?.length === ((this.activityService.selectedSize )) ? false : true;
    }

    else {
      this.additionalSecondaryGuestCount = this.secondaryGuestDetails?.length === (this.activityService.selectedSize - 1) ? false : true;
    }
    this.guestData.emit({ formValid: this.isFormValid(this.components?.first.form) && !this.mandatoryCategoryAddons?.length, guestContact: this.primaryContact , secondaryContact: this.secondaryGuestDetails });
  }
  isFormValid(form: FormGroup): boolean {
    return Object.values(form.controls).every(control => {
      return control.valid || (control.disabled && control.errors === null);
    });
  }
  secondaryGuestNotes(event) {
    this.toggleSelection(event.noteOptions);
  }

  secondaryGuestValid(updatedContact) {
    let contactIndex = this.secondaryGuestDetails.findIndex(contact => ((contact.count !== null && contact.count !== undefined) && (contact.count == updatedContact.count)) || (contact.Id && contact.Id == updatedContact.Id))
    
    if (contactIndex === -1) {
        contactIndex = this.secondaryGuestDetails.findIndex(contact =>
          !contact.Id && !contact.FirstName && !contact.LastName && !contact.EmailAddress
        );
      }

    if(contactIndex >= 0){
      let updatedValue = Object.assign(this.secondaryGuestDetails[contactIndex], updatedContact);
      this.secondaryGuestDetails[contactIndex] = updatedValue;
      
    }
    else{
      let updatedValue = Object.assign(this.secondaryGuestDetails[0], updatedContact);
      this.secondaryGuestDetails[0] = updatedValue;
      
    }

    this.guestData.emit({ formValid: this.isFormValid(this.components.first.form) && !this.mandatoryCategoryAddons?.length, guestContact: this.primaryContact, secondaryContact: this.secondaryGuestDetails });
  }

  resetSecondaryNotes(notes) {
    notes?.forEach(note => {
      if (note?.checkBoxOptions && note.checkBoxOptions?.length) {
        note.checkBoxOptions = note.checkBoxOptions?.map(x => { return { id: x.id, value: x.value, selected: false, icon: x.icon } });
      }
      if (note.commentsBox) {
        note.commentsBox.value = '';
      }
    });
    return notes;
  }

  isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  validateAddOnsQtyOnChange(item) {
    setTimeout(() => {
      if(item.selectedQuantity)
      item.selectedQuantity = Math.floor(item.selectedQuantity);
    }, 10);
  }

}

@Pipe({
    name: 'viewMore',
    standalone: false
})
export class viewMorePipe implements PipeTransform {

  transform(data: any, count): any {
    return (data.splice(0, count - 1))
  }
}

@Pipe({
    name: 'getCategoryData',
    standalone: false
})
export class GetCategoryDataPipe implements PipeTransform {
  transform(addOn: any, categories, property): any {

    let data = categories.find(category => category.Id == addOn.CategoryId)
    return property == 'Color' ? `rgba(${data.Color.R}, ${data.Color.G}, ${data.Color.B}, ${data.Color.A})` : data.Text;

  }
}
